import { JiraFieldKey } from "@/const/jira.constants"

// Core fields of a ticket for every vendor but Jira
export const TICKET_FIELD_KEYS = {
  project: "project",
  type: "type",
  title: "title",
  description: "description"
} as const

// Core fields of the shared ticket modal: Jira keeps its own keys
export const TICKET_MODAL_FIELD_KEYS = {
  jira: {
    project: JiraFieldKey.Project,
    type: JiraFieldKey.IssueType,
    title: JiraFieldKey.Summary,
    description: JiraFieldKey.Description
  },
  vendor: TICKET_FIELD_KEYS
} as const

// Above drawers, like the Jira issue modal
export const TICKET_MODAL_Z_INDEX = 1201

export const NO_INTEGRATION_CREATE_BUTTON_KEY =
  "jiraIssueModal.noIntegrationCreateButton"
